import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "mb-4 rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_3 = { class: "mb-4 flex flex-wrap gap-2" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-3 lg:grid-cols-[180px_180px_minmax(260px,1fr)_auto]" }
const _hoisted_5 = { class: "flex min-w-0 flex-col gap-1.5" }
const _hoisted_6 = { class: "date-picker" }
const _hoisted_7 = {
  key: 0,
  class: "date-picker-panel"
}
const _hoisted_8 = { class: "date-picker-header" }
const _hoisted_9 = { class: "date-picker-weekdays" }
const _hoisted_10 = { class: "date-picker-days" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "date-picker-actions" }
const _hoisted_13 = { class: "flex min-w-0 flex-col gap-1.5" }
const _hoisted_14 = { class: "date-picker" }
const _hoisted_15 = {
  key: 0,
  class: "date-picker-panel"
}
const _hoisted_16 = { class: "date-picker-header" }
const _hoisted_17 = { class: "date-picker-weekdays" }
const _hoisted_18 = { class: "date-picker-days" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "date-picker-actions" }
const _hoisted_21 = { class: "flex min-w-0 flex-col gap-1.5" }
const _hoisted_22 = { class: "relative flex min-w-0" }
const _hoisted_23 = { class: "flex items-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách văn bản" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              type: "button",
              label: `Chưa trả lời (${$setup.pendingCount})`,
              icon: "pi pi-hourglass",
              outlined: $setup.activeTab !== 'pending',
              severity: "danger",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.activeTab = 'pending'))
            }, null, 8, ["label", "outlined"]),
            _createVNode(_component_Button, {
              type: "button",
              label: `Đã trả lời (${$setup.answeredCount})`,
              icon: "pi pi-check",
              outlined: $setup.activeTab !== 'answered',
              severity: "success",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.activeTab = 'answered'))
            }, null, 8, ["label", "outlined"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-sm font-bold text-slate-600" }, "Từ thời gian", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  class: "date-picker-input",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleDatePicker('from')))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'date-picker-placeholder': !$setup.dateFrom })
                  }, _toDisplayString($setup.formatDatePickerValue($setup.dateFrom) || "dd/mm/yyyy"), 3),
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
                ]),
                ($setup.openPicker === 'from')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.moveCalendarMonth(-1)))
                        }, [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
                        ]))]),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentMonthLabel), 1),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.moveCalendarMonth(1)))
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
                        ]))])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.weekDays, (day) => {
                          return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(day), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.calendarDays, (day) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: day.key,
                            type: "button",
                            class: _normalizeClass({ muted: !day.inMonth, selected: day.value === $setup.dateFrom, today: day.isToday }),
                            onClick: ($event: any) => ($setup.selectDate('from', day.value))
                          }, _toDisplayString(day.label), 11, _hoisted_11))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.selectTodayDate('from')))
                        }, "Hôm nay"),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.clearDate('from')))
                        }, "Xóa")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-sm font-bold text-slate-600" }, "Đến thời gian", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "date-picker-input",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggleDatePicker('to')))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'date-picker-placeholder': !$setup.dateTo })
                  }, _toDisplayString($setup.formatDatePickerValue($setup.dateTo) || "dd/mm/yyyy"), 3),
                  _cache[19] || (_cache[19] = _createElementVNode("i", { class: "pi pi-calendar" }, null, -1))
                ]),
                ($setup.openPicker === 'to')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.moveCalendarMonth(-1)))
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
                        ]))]),
                        _createElementVNode("strong", null, _toDisplayString($setup.currentMonthLabel), 1),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.moveCalendarMonth(1)))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
                        ]))])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.weekDays, (day) => {
                          return (_openBlock(), _createElementBlock("span", { key: day }, _toDisplayString(day), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.calendarDays, (day) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: day.key,
                            type: "button",
                            class: _normalizeClass({ muted: !day.inMonth, selected: day.value === $setup.dateTo, today: day.isToday }),
                            onClick: ($event: any) => ($setup.selectDate('to', day.value))
                          }, _toDisplayString(day.label), 11, _hoisted_19))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.selectTodayDate('to')))
                        }, "Hôm nay"),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.clearDate('to')))
                        }, "Xóa")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-sm font-bold text-slate-600" }, "Tìm kiếm", -1)),
              _createElementVNode("span", _hoisted_22, [
                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400" }, null, -1)),
                _createVNode(_component_InputText, {
                  class: "!w-full !pl-10 !pr-3",
                  modelValue: $setup.filters['global'].value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.filters['global'].value) = $event)),
                  placeholder: "Tìm theo tiêu đề hoặc người gửi"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: "Xoá lọc",
                outlined: "",
                onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.clearFilter()))
              })
            ])
          ])
        ]),
        _createVNode(_component_DataTable, {
          value: $setup.visibleDocuments,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10, 25, 50],
          rowHover: true,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          filters: $setup.filters,
          "onUpdate:filters": _cache[14] || (_cache[14] = ($event: any) => (($setup.filters) = $event)),
          globalFilterFields: ['title', 'sender'],
          currentPageReportTemplate: "Có tổng số {totalRecords} văn bản",
          resizableColumns: "",
          tableclass: "h-[60px]"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "title",
              header: "Tiêu đề văn bản",
              sortable: "",
              class: "h-[60px]"
            }),
            _createVNode(_component_Column, {
              field: "sender",
              header: "Người gửi",
              class: "h-[60px]",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "time",
              header: "Thời gian",
              class: "h-[60px]",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.time)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "replyDeadline",
              header: "Hạn trả lời",
              class: "h-[60px]",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.deadlineClass(slotProps.data))
                }, _toDisplayString($setup.formatDeadline(slotProps.data.replyDeadline)), 3)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "status",
              header: "Trạng thái",
              class: "h-[60px]",
              sortable: ""
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.status)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      outlined: "",
                      label: "Đã xử lý",
                      icon: "pi pi-check",
                      onClick: ($event: any) => ($setup.goToViewDocument(slotProps.data.id))
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      outlined: "",
                      severity: "danger",
                      label: "Chưa xử lý",
                      icon: "pi pi-hourglass",
                      onClick: ($event: any) => ($setup.goToViewDocument(slotProps.data.id))
                    }, null, 8, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"])
      ])
    ]),
    _: 1
  }))
}